import axios from "axios";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_FAIL,
} from "../constant/UserConstant";
import api from "../core/api";

export const userLogin = (userJson) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.post(
      `/api/report/users/login`,
      userJson,
      config
    );

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: dt,
      });
    } else {
      let dte = new Date().getTime();
      localStorage.setItem("_ssat", data.accesstoken);
      localStorage.setItem("_sset", JSON.stringify(data.Result));
      localStorage.setItem("_daex", dte);
      const userId = data.Result[0].Users_Id;
      var IPaddress = "";
      await axios
        .get(`https://ipjson.searcheducation.in/getip`)
        .then((rec) => {
          IPaddress = rec.data.ip;
        });
      const addJson = {
        UserId: userId,
        LoginIP: IPaddress,
        LoginDate: new Date(),
        Comment: "LoggedIn Successfully on Report Dashboard",
      };
      await api.post(`/users/loginrec`, addJson).then((rec) => {});
      dispatch({
        type: USER_LOGIN_SUCCESS,
        payload: "Login Successfull!",
        rec: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};

export const userLogout = () => async (dispatch) => {
  localStorage.removeItem("_ssat");
  localStorage.removeItem("_daex");
  localStorage.removeItem("_sset");
};

export const getUsersList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_LIST_REQUEST,
    });

    const { data } = await api.get(`/users`);

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: USER_LIST_FAIL,
        payload: dt,
      });
    } else {
      dispatch({
        type: USER_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: USER_LIST_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};
